"use client";

import { useAuth } from "@/features/auth/shared/hooks/use-auth";
import { useLang } from "@/hooks/use-lang";

import { Skeletons } from "ui/widget/skeletons";

import { useWgptQuota } from "../services/get-wgpt-quota";

export const UsageTitle = () => {
  const { t } = useLang();
  const { data, isLoading, isError } = useWgptQuota();
  const { profile } = useAuth();
  const isPeriodicRenewalPlan =
    profile?.plan.includes("Basic") || profile?.plan.includes("Premium");

  const usageDescription = isPeriodicRenewalPlan
    ? t.winwingpt.quota
    : t.winwingpt.freeQuota;
  const counts =
    data?.available !== undefined && data?.remains !== undefined
      ? Math.max(data.available - data.remains, 0)
      : 0;

  if (isLoading || isError)
    return (
      <div>
        <Skeletons className="pt-2" columns={1} rows={1} />
      </div>
    );

  return (
    <div className="flex flex-wrap items-baseline gap-2 text-zinc-500">
      <h3>{t.winwingpt.inquiryRecord}</h3>
      <p data-testid="quota" className="text-xs">
        {usageDescription({
          counts,
          available: data.available,
        })}
      </p>
    </div>
  );
};
